import { RestMethod } from "app/_helpers/ApiConfig/RestMethod";
import { USER_DATA_CONSTANT } from "app/_constants/Redux/userData.constant";
import configureStore from "../../redux/Store";
let { Store } = configureStore();
export async function getAllFormA(filter) {
  const url = "/user-management/form-a";
  try {
    const formAData = Store.getState()?.userManagement?.formA;
    if (
      Array.isArray(formAData?.data?.data?.list) &&
      formAData?.data?.data?.list?.length
    ) {
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve({
            status: 1,
            message: "Data from store",
            data: { list: formAData.data.data.list },
          });
        }, 0);
      });
    } else {
      const response = await RestMethod.GET(url);
      if (response.data.status) {
        Store.dispatch({
          type: USER_DATA_CONSTANT.FORM_A,
          data: response.data,
        });
      }
      console.log("returning value------------", response.data);
      return response.data;
    }
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}
